/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoChangeContainerStageInput = {
    clientMutationId?: string | null;
    slug: string;
    stage: string;
};
export type ContainerReleaseConfirmStageChangeMutationVariables = {
    input: infoChangeContainerStageInput;
};
export type ContainerReleaseConfirmStageChangeMutationResponse = {
    readonly infoChangeContainerStage: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ContainerReleaseConfirmStageChangeMutation = {
    readonly response: ContainerReleaseConfirmStageChangeMutationResponse;
    readonly variables: ContainerReleaseConfirmStageChangeMutationVariables;
};



/*
mutation ContainerReleaseConfirmStageChangeMutation(
  $input: infoChangeContainerStageInput!
) {
  infoChangeContainerStage(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoChangeContainerStagePayload",
    "kind": "LinkedField",
    "name": "infoChangeContainerStage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContainerReleaseConfirmStageChangeMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContainerReleaseConfirmStageChangeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2085894faeb95a5b79e6021a4e46ce9b",
    "id": null,
    "metadata": {},
    "name": "ContainerReleaseConfirmStageChangeMutation",
    "operationKind": "mutation",
    "text": "mutation ContainerReleaseConfirmStageChangeMutation(\n  $input: infoChangeContainerStageInput!\n) {\n  infoChangeContainerStage(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '66f42078efaa76699f1c71709fc836e6';
export default node;
